import React, { useEffect, useState } from 'react';
import Navbar from './Navbar';
import Sidebar from './Sidebar';
import useFetch from 'utils/hooks/useFetch';
import { ApiCheckAuth } from 'utils/constants/api';
import { ApiResponseStatusUnauthorized } from 'utils/Constant';
// import Cookies from 'js-cookie'

export default function MainContainer({ children }) {
	const { fetch: checkAuth } = useFetch(ApiCheckAuth)
	
	let pathName = window.location.pathname
	let pathArray = pathName.split("/")

	const [isSidebarOpen, setIsSidebarOpen] = useState(localStorage.getItem("SidebarState") === "open");

	const toggleSidebar = () => {
		setIsSidebarOpen(prev => {
			const newState = !prev;
			localStorage.setItem("SidebarState", newState ? "open" : "close");
			return newState;
		});
	};
	const onSidebarClick = () => {
		// toggleSidebar()
	}

	useEffect(() => {
		if (pathArray[1] !== "login"){
			if (localStorage.getItem("Token") ===  null){
				window.location.href = "/login"
			}
			fCheckAuth()
		}
	}, [])

	if (pathArray[1] === "login"){
		return(
			<div className="overflow-hidden">
				<div className="">{ children }</div>
			</div>
		)
	}

	// Function Call API
	async function fCheckAuth(){
		await checkAuth({
			data: {}
		}).then((response) => {
			if(response.status === ApiResponseStatusUnauthorized){
				window.location.href = "/login"
			}
		})
	}

	function fToggleSidebar(state){
		if (state){
			localStorage.setItem("SidebarState", "close")
		}else{
			localStorage.setItem("SidebarState", "open")
		}

		setIsSidebarOpen(!state)
	}

	return (
		<div className="overflow-hidden h-screen w-full flex flex-col bg-black text-sm">
			<div className="sm:hidden sticky top-0 left-0 bottom-0 z-30 shadow-md">
				<Navbar toggleSidebar={() => { fToggleSidebar(isSidebarOpen) }} />
			</div>
			<div className='w-full h-screen overflow-hidden flex bg-white'>
				<div className='sticky top-0 z-30'>
					<Sidebar isOpen={isSidebarOpen} toggleSidebar={toggleSidebar} onSidebarClick={onSidebarClick} />
				</div>
				<div className='w-full overflow-auto bg-white sm:bg-slate-50 text-sm 2xl:text-base'>
					{ children }
				</div>
			</div>
		</div>		
	)
}
